export const navLinks = [
  {
    label: 'Projects',
    pathname: '/',
    hash: '#blair3sat',
  },
  {
    label: 'Articles',
    pathname: '/articles',
  },
  {
    label: 'About',
    pathname: '/',
    hash: '#about',
  },
  {
    label: 'Resume',
    pathname: '/resume',
  },
  {
    label: 'Contact',
    pathname: '/contact',
  },
];

export const socialLinks = [
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/vijay-shanmugam/',
    icon: 'linkedin',
  },
  {
    label: 'Github',
    url: 'https://github.com/Jbolt01',
    icon: 'github',
  },
  {
    label: 'Twitter',
    url: 'https://twitter.com/realvijayrs',
    icon: 'twitter',
  },
  {
    label: 'Email',
    url: 'mailto:vijayrshan@gmail.com',
    icon: 'email',
  },
];
